<div class="accordion" id="accordionExample" style="margin-top: -25px;">
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading3">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse3"
                    aria-expanded="false" aria-controls="collapse3">
                Inhoudingsvrijstelling
            </button>
        </h2>
        <div id="collapse3" class="accordion-collapse collapse" aria-labelledby="heading3"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                De inhoudingsvrijstelling is een regeling die voorkomt dat een vennootschap dividendbelasting
                hoeft in
                te houden bij de uitkering van dividend aan een andere vennootschap, onder bepaalde voorwaarden.
                Dit
                betekent dat als een moedermaatschappij dividend uitkeert aan een dochtermaatschappij, de
                dividendbelasting niet hoeft te worden ingehouden, wat belastingheffing dubbel voorkomt.
                <div class="space20"></div>

                <b>Voorwaarden voor de inhoudingsvrijstelling</b><br/>
                De inhoudingsvrijstelling geldt in Nederland als aan de volgende voorwaarden wordt voldaan:
                <ul>
                    <li>De ontvanger moet een vennootschap zijn: De dividendontvanger moet een vennootschap zijn
                        die
                        zelf
                        belastingplichtig is in Nederland. Dit betekent dat de regeling alleen geldt voor andere
                        rechtspersonen,
                        zoals bijvoorbeeld een BV of NV.
                    </li>
                    <li> De ontvanger moet een bepaald percentage van de aandelen bezitten: De vennootschap die
                        het
                        dividend
                        ontvangt, moet minimaal 5% van de aandelen in de uitkerende vennootschap bezitten. Dit
                        geldt
                        zowel voor
                        directe als indirecte deelnemingen.
                    </li>
                    <li>De deelneming moet kwalificeren als een "deelneming" in fiscale zin: De deelneming moet
                        als een
                        "fiscale
                        deelneming" worden beschouwd. Dit betekent dat er geen sprake mag zijn van bijvoorbeeld
                        speculatieaandelen, maar dat het een strategische en duurzame investering betreft.
                    </li>
                </ul>

                Als aan deze voorwaarden wordt voldaan, hoeft de vennootschap die het dividend uitkeert geen
                dividendbelasting in te houden. Keert de vennootschap deelnemingsdividend uit aan een
                aandeelhouder
                (in veel gevallen de moedermaatschappij) die gevestigd is in
                Nederland? Dan kan de vennootschap meestal een inhoudingsvrijstelling toepassen op de uitkering.
                Is de
                hele uitkering vrijgesteld? Dan hoef je geen aangifte te doen.

                <div class="space20"></div>
                <b>Wanneer geldt dit niet?</b><br/>
                <ul>
                    <li>
                        Als de vennootschap die het dividend ontvangt geen 5% of meer van de aandelen bezit in
                        deuitkerende vennootschap.
                    </li>
                    <li>
                        Als de ontvanger geen vennootschap is (bijvoorbeeld een natuurlijke persoon).
                    </li>
                    <li>
                        Als er sprake is van een "speculatieve" deelneming die niet als een duurzame deelneming
                        wordt beschouwd.
                    </li>
                </ul>
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading1">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse1"
                    aria-expanded="false" aria-controls="collapse1">
                Soorten inhoudingsvrijstelling
            </button>
        </h2>
        <div id="collapse1" class="accordion-collapse collapse show" aria-labelledby="heading1"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Er zijn divers vrijstellingen waardoor er geen dividendbelasting ingehouden hoeft te worden.
                <div class="space20"></div>
                <ul>
                    <li>Deelnemingsvrijstelling</li>
                    <li>Fiscale eenheid</li>
                    <li>Uitkering door een aangewezen bank- of beleggingsinstelling (groene belegging)</li>
                    <li>Uitkering door een Natuurschoonwetlichaam</li>
                    <li>Uitkering door een beleggingsinstelling voor lijfrente- of stamrechtbeleggingsrechten</li>
                    <li>Uitkering aan een (gedeeltelijk) niet aan vennootschapsbelasting onderworpen vennootschap die
                        over een
                        kwalificatiebeschikking beschikt
                    </li>
                    <li>Vererfd aanmerkelijk belang</li>
                </ul>
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading2">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse2"
                    aria-expanded="false" aria-controls="collapse2">
                Geen aangifte voor alleen maar (deelnemings)dividend met inhoudingsvrijstelling
            </button>
        </h2>
        <div id="collapse2" class="accordion-collapse collapse show" aria-labelledby="heading2"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Keert de vennootschap deelnemingsdividend uit aan een aandeelhouder die gevestigd is in
                Nederland? Dan kan de vennootschap meestal een inhoudingsvrijstelling toepassen op de uitkering. Is de
                hele uitkering vrijgesteld? Dan hoef je geen aangifte te doen.
            </div>
        </div>
    </div>
</div>
